import OnlineSalesOrderCont from '../../../components/Sales/Orders/OnlineSalesOrder/OnlineSalesOrderCont'
import React, { Component, Fragment } from 'react'
import List from './OrdersList'
import InvoiceModalCont from '../../../components/Common/InvoiceModal/InvoiceModalCont'
import { idMaker } from '../../../modules/Utils'
import { Breadcrumb, Tabs } from 'antd'
import { Card } from 'antd'
import { Row } from 'antd'
import { Icon } from 'antd'
import OrderLinesList from '../../../components/Sales/Orders/OrderLinesList'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'
import style from '../../../components/Sales/Payments/style.css'
import useTitle from '../../../elements/Hooks/useTitle'

const { TabPane } = Tabs

const ids = idMaker()
function Orders(props) {
  useTitle('Sales Orders')
  return (
    <div>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item>Sales Orders</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className={style.title}>
            <Icon type="schedule" theme="twoTone" style={{ marginRight: 10 }} />
            Sales Orders
          </h1>
          <p className={style.paragraph}>View and list client Sales Orders.</p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <InvoiceModalCont key={ids.next().value} {...props} type={'combo'} />
        {/*<Tabs*/}
        {/*  defaultActiveKey={get(props, 'location.hash') || '#list'}*/}
        {/*  onChange={(key) => props.history.push(key)}*/}
        {/*  tabPosition={'top'}>*/}
          {/*<TabPane tab="Orders" key="#list">*/}
            <List {...props} />
          {/*</TabPane>*/}
          {/*<TabPane tab="Orders Lines" key="#order-lines-list">
            <OrderLinesList {...props} />
          </TabPane>*/}
          {/*<TabPane tab="Online Sales" key="#online-order-list">*/}
          {/*  <OnlineSalesOrderCont {...props} />*/}
          {/*</TabPane>*/}
        {/*</Tabs>*/}
      </Card>
    </div>
  )
}

Orders.propTypes = {}
Orders.defaultProps = {}

export default withRouter(Orders)
